// components
import toast from "components/Toast/dispatch";
// interfaces
import { ProductsSuggestionProps } from "../MapProduct/interface";
// models
import { IQuoteDetailItem } from "models/QuoteDetailItem";
import { ICompetitorPrice } from "models/MapProduct";
import { IUser } from "models/User";
// utils
import { capitalizeFirstLetter } from "../Details/utils";

const toastNonstandardCode = () => (
  toast.info("Atenção", "Código da cotação fora de 'padrão', abrir chamado na Bionexo para o mesmo ser corrigido.")
);

const toastNotPermissionUnlock = () => toast.error('Você não tem permissão para desbloquear essa cotação.');

const userSavedIsAutomatic = (item: any) => (item?.budgetSaved?.name === "Resposta Automática");

const handleUserRedirect = (user: IUser, history: any) => {
  const customerTypeUser = user.userType && user.userType === 'customer';

  if (customerTypeUser) {
    history.push('/dashboard');
  }
};

const mapSaveSuggestion = (
  suggestion: ProductsSuggestionProps,
  conversionAmount: string | number,
  unitPrice: string | number,
  rentability: string | number,
  quantity: number,
  distributionCenter: string,
  competitorPrice: ICompetitorPrice,
  conversionFactor: number | null,
  subUnidValue: number | null) => {
  const stock = suggestion.itemStock ? suggestion.itemStock.find(stock => stock.local === distributionCenter) : null;

  return {
    itemStock: stock,
    distributionCenter,
    quantity: quantity,
    salePrice: unitPrice,
    unitPrice: subUnidValue,
    rentability: rentability,
    subUnit: suggestion.subUnit,
    itemBatch: suggestion.itemBatch,
    suggested: suggestion.suggested,
    substance: suggestion.substance,
    competitorPrice: competitorPrice,
    isApproved: suggestion.isApproved,
    multiple: suggestion.multiple || 1,
    conversionAmount: conversionAmount,
    conversionFactor: conversionFactor,
    medicineType: suggestion.medicineType,
    subUnitValue: suggestion.subUnitValue,
    refrigeration: suggestion.refrigeration,
    typeMapCreated: suggestion.typeMapCreated,
    productSegment: suggestion.productSegment,
    supplierProductcode: suggestion.supplierProductcode,
    supplierProductCodeRA: suggestion.supplierProductCodeRA,
    sequentialSuggestion: suggestion.sequentialSuggestion,
    purchaseUnit: suggestion.unit ?? suggestion.purchaseUnit,
    isCreatedAutomatically: suggestion.isCreatedAutomatically,
    manufacturer: suggestion.producer ?? suggestion.manufacturer,
    medicineTypeDescription: capitalizeFirstLetter(suggestion.medicineTypeDescription),
    productSegmentDescription: capitalizeFirstLetter(suggestion.productSegmentDescription),
    supplierProductDescription: suggestion.description ?? suggestion.supplierProductDescription
  };
};

const handleCreatePdf = (response: any, fileName: string, supplierProductcode?: any, quotationCode?: string, distributionCenter?: string, preOrderMirror?: boolean) => {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;

  if (preOrderMirror) {
    link.setAttribute('download', `${fileName}-${quotationCode}-${distributionCenter}.pdf`);
  } else {
    link.setAttribute('download', `${fileName}-${supplierProductcode}.pdf`);
  }

  document.body.appendChild(link);
  link.click();
};

export {
  handleCreatePdf,
  mapSaveSuggestion,
  handleUserRedirect,
  toastNonstandardCode,
  userSavedIsAutomatic,
  toastNotPermissionUnlock
};